import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";

export function useBasePath(count) {

    const [basePath, setBasePath] = useState("/")
    const location = useLocation()

    useEffect(() => {
        let items = location.pathname.split('/')

        if (items.length > count)
            setBasePath(items.slice(0, count + 1).join('/'))
        else
            setBasePath(items.join('/'))

    }, [location]);

    return basePath
}
